// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class ASRSegment {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ASRSegment {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsASRSegment(bb: flatbuffers.ByteBuffer, obj?: ASRSegment): ASRSegment {
    return (obj || new ASRSegment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsASRSegment(bb: flatbuffers.ByteBuffer, obj?: ASRSegment): ASRSegment {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ASRSegment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  startTime(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0
  }

  endTime(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0
  }

  confidence(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0
  }

  static startASRSegment(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, textOffset, 0)
  }

  static addStartTime(builder: flatbuffers.Builder, startTime: number) {
    builder.addFieldFloat64(1, startTime, 0.0)
  }

  static addEndTime(builder: flatbuffers.Builder, endTime: number) {
    builder.addFieldFloat64(2, endTime, 0.0)
  }

  static addConfidence(builder: flatbuffers.Builder, confidence: number) {
    builder.addFieldFloat32(3, confidence, 0.0)
  }

  static endASRSegment(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // text
    return offset
  }

  static createASRSegment(
    builder: flatbuffers.Builder,
    textOffset: flatbuffers.Offset,
    startTime: number,
    endTime: number,
    confidence: number
  ): flatbuffers.Offset {
    ASRSegment.startASRSegment(builder)
    ASRSegment.addText(builder, textOffset)
    ASRSegment.addStartTime(builder, startTime)
    ASRSegment.addEndTime(builder, endTime)
    ASRSegment.addConfidence(builder, confidence)
    return ASRSegment.endASRSegment(builder)
  }
}
